import React from 'react';
import { makeStyles, Theme } from '@material-ui/core';
import { colors } from '../../../theme/tokens';

const useStyles = makeStyles((theme: Theme) => ({
  // minWidth: 0 overrides the flex-item default (min-width: auto), which
  // otherwise refuses to shrink below a scrollable child's intrinsic content
  // width — without it, a wide chart forces this card (and the whole page)
  // wider instead of scrolling internally.
  wrap: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    minWidth: 0,
  },
  headerRow: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 8,
    marginBottom: 10,
  },
  title: {
    fontSize: 11,
    fontWeight: 700,
    color: colors.textFaint,
    textTransform: 'uppercase' as any,
    letterSpacing: '0.06em',
  },
  card: {
    background: colors.bgSurface,
    borderRadius: 12,
    border: `1px solid ${colors.border}`,
    padding: '18px 20px',
    boxShadow: `0 1px 3px ${colors.shadow}`,
    flex: 1,
    minWidth: 0,
    boxSizing: 'border-box' as any,
    [theme.breakpoints.down('xs')]: { padding: '14px 14px' },
  },
  emptyText: {
    fontSize: 13,
    color: colors.textDisabled,
    textAlign: 'center' as any,
    padding: '24px 0',
  },
}));

export interface ChartCardProps {
  title: string;
  headerRight?: React.ReactNode;
  children: React.ReactNode;
  isEmpty?: boolean;
  emptyText?: string;
}

export default function ChartCard({
  title,
  headerRight,
  children,
  isEmpty,
  emptyText = 'No data yet',
}: ChartCardProps) {
  const classes = useStyles();
  return (
    <div className={classes.wrap}>
      <div className={classes.headerRow}>
        <div className={classes.title}>{title}</div>
        {headerRight}
      </div>
      <div className={classes.card}>
        {isEmpty ? (
          <div className={classes.emptyText}>{emptyText}</div>
        ) : (
          children
        )}
      </div>
    </div>
  );
}
